// extracted by mini-css-extract-plugin
export var growableInput = "_6a-0";
export var tagContainer = "_6a-2";
export var textInput = "_6a-1";